import React from 'react';

const Anchor = ({ anchor, children }) => {
    return anchor ? <div id={anchor}>{children}</div> : <>{children}</>;
}

export default Anchor;